import { LessonDTO } from '@/data/services/lessonServices';
import Lesson from '@/models/Lesson';
import { LessonFields } from '@/components/_deprecated/courses/box/lesson/LessonBoxForm';
import { urlValidate } from '../urlValidate';

export const adapterLessonToLessonDTO = (
  lesson: Partial<Lesson>,
): Partial<LessonDTO> => {
  return {
    ...lesson,
    tools: lesson.tools?.map(tool => tool.id),
  };
};

export const adapterLessonFieldsToLessonDTO = (
  lesson: Partial<LessonFields>,
): Partial<LessonDTO> => {
  const lessonDTO = {
    ...lesson,
    tools: lesson.tool ? [lesson.tool] : undefined,
  };
  delete lessonDTO.tool;
  return lessonDTO;
};

export const adapterLessonToLessonFields = (
  lesson: Partial<Lesson>,
): Partial<LessonFields> => {
  return {
    ...lesson,
    tool: lesson.tools?.[0]?.id,
  };
};

const tratateLink = (link?: string) => {
  if (!link) return undefined;
  return urlValidate(link);
};

export const tratateLinks = (
  lessonFields: Partial<LessonFields>,
): Partial<LessonFields> => {
  return {
    ...lessonFields,
    instructionsUrl: tratateLink(lessonFields.instructionsUrl),
    toolUrl: tratateLink(lessonFields.toolUrl),
  };
};
